import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AdminUtilsService {
  isValidEmail(email: string): boolean {
    // Simple regex based email validation (https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript)
    return (
      email.match(
        // eslint-disable-next-line no-useless-escape,max-len
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      ) !== null
    );
  }
}
